import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";

export default function sendChatRating(rating: "bad" | "good"): ChatServerAsyncActionType {
    return chatServer => () => {
        chatServer.sendChatRating(rating);
    };
}